import { handleActions } from 'redux-actions'
import {
  closeDialog,
  openDialog,
  openDialogWithParams
} from '../actions/dialogs'
import { Action, DialogsState } from './types'

const initialState: DialogsState = {
  visibility: {
    id: undefined,
    isVisible: false
  }
}

const dialogs = handleActions<DialogsState, any>(
  {
    [openDialog]: (state, { payload: id }: Action<string>) => ({
      ...state,
      visibility: {
        id,
        isVisible: true
      }
    }),
    [openDialogWithParams]: (
      state,
      {
        payload: { id, params }
      }: Action<{ id: string; params: Record<string, unknown> }>
    ) => ({
      ...state,
      visibility: {
        id,
        isVisible: true
      },
      [id]: params
    }),
    [closeDialog]: (state, { payload: id }: Action<string>) => ({
      ...state,
      visibility: {
        id,
        isVisible: false
      }
    })
  },
  initialState
)

export default dialogs
